import { render } from "./AppContainer.vue?vue&type=template&id=5f20fb93"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__